export default __webpack_public_path__ + "static/media/118e930e-1f56-4131-aee9-236212c0a10b.76a31030.ttf";